'use client';

function Bar({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-full bg-gray-200 ${className}`} />;
}

/** Also stands in for a serve card: same art-then-copy shape. */
export function EventCardSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white">
      <div className="aspect-video w-full animate-pulse bg-gray-200" />
      <div className="flex flex-col gap-3 p-5">
        <Bar className="h-3 w-28" />
        <Bar className="h-5 w-3/4" />
        <Bar className="h-4 w-full" />
        <Bar className="h-4 w-2/3" />
        <div className="mt-1 flex gap-2">
          <Bar className="h-7 w-20" />
          <Bar className="h-7 w-16" />
        </div>
      </div>
    </div>
  );
}

export const ServeCardSkeleton = EventCardSkeleton;

export function GroupCardSkeleton() {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-5 sm:p-6">
      <Bar className="h-6 w-2/3 max-w-sm" />
      <div className="grid gap-4">
        <div className="flex flex-col gap-3">
          <Bar className="h-4 w-32" />
          <Bar className="h-4 w-40" />
          <Bar className="h-4 w-24" />
          <div className="mt-1 flex items-center gap-2">
            <div className="h-7 w-7 animate-pulse rounded-full bg-gray-200" />
            <Bar className="h-4 w-28" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Bar className="h-4 w-full" />
          <Bar className="h-4 w-11/12" />
          <Bar className="h-4 w-3/4" />
        </div>
      </div>
      <div className="flex items-center justify-between gap-3">
        <div className="flex gap-2">
          <Bar className="h-7 w-24" />
          <Bar className="h-7 w-28" />
          <Bar className="h-7 w-20" />
        </div>
        <Bar className="h-9 w-24" />
      </div>
    </div>
  );
}
